export default __webpack_public_path__ + "static/media/tooltip-rocket.3e886932.svg";